export class FormDocument {
  public description: string;
  public formId: string;
  public isMandatory: boolean;
  public name: string;
  public definitions: string;

  constructor(description: string, formId: string, isMandatory: boolean, name: string, definitions: string) {
    this.description = description;
    this.formId = formId;
    this.isMandatory = isMandatory;
    this.name = name;
    this.definitions = definitions;
  }
}
